import { Grid, Stack } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import { Skeleton } from '@feathr/components';

function DashboardPageSkeleton(): JSX.Element {
  return (
    <Stack gap={'xl'} p={'xl'}>
      <Skeleton paragraphs={1} width={300} />

      <Grid gutter={'md'}>
        <Grid.Col span={{ base: 12, sm: 6, lg: 4 }}>
          <Skeleton paragraphs={3} width={'100%'} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, lg: 4 }}>
          <Skeleton paragraphs={3} width={'100%'} />
        </Grid.Col>
        <Grid.Col span={{ base: 12, sm: 6, lg: 4 }}>
          <Skeleton paragraphs={3} width={'100%'} />
        </Grid.Col>
      </Grid>

      <Skeleton paragraphs={5} width={'100%'} />
    </Stack>
  );
}

export default DashboardPageSkeleton;
